import type { SearchCategory } from '@/app/_components/SearchBar/constants';

export const PAGE_SIZE = 10;
export const PREVIEW_SIZE = 5;

export const EMPTY_SEARCH_RESULT_MESSAGE = '검색 결과가 없습니다.';
export const EMPTY_AI_SUMMARY_MESSAGE = '요약 정보가 아직 준비되지 않았어요.';
export const EMPTY_SUPPORT_BENEFIT_MESSAGE =
  '지원 혜택 정보가 아직 준비되지 않았어요.';

export interface FilterOption<T extends string | number> {
  value: T;
  label: string;
}

/**
 * 카테고리별 검색바 최대 폭 (xl 이상).
 * = leftAside + gap + main(600) + gap + rightAside, DesktopPageShell 컬럼 합과 일치.
 *  - filter aside w-202, popular/ad aside w-250, gap-24, main rail w-[600px]
 *  - both: 202 + 24 + 600 + 24 + 250 = 1100
 *  - right only: 600 + 24 + 250 = 874
 */
export const SECTION_HEADER_MAX_W: Record<SearchCategory, string> = {
  all: 'xl:max-w-[874px]',
  policy: 'xl:max-w-[1100px]',
  'policy-info': 'xl:max-w-[1100px]',
  'hometown-news': 'xl:max-w-[826px]',
  gifts: 'xl:max-w-[1100px]',
  'hometown-business': 'xl:max-w-[1100px]',
  welmarket: 'xl:max-w-[874px]',
};
